module.exports = {"341024100":"祁山镇","341024101":"小路口镇","341024102":"金字牌镇","341024103":"平里镇","341024104":"历口镇","341024105":"闪里镇","341024106":"安凌镇","341024107":"凫峰镇","341024108":"塔坊镇","341024109":"新安镇","341024200":"大坦乡","341024202":"柏溪乡","341024204":"祁红乡","341024205":"溶口乡","341024206":"芦溪乡","341024207":"渚口乡","341024208":"古溪乡","341024210":"箬坑乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341024.json
// module id = 1020
// module chunks = 0